import { gql } from '@apollo/client';
const SBR_CART_DEACTIVATE = gql`
    mutation sbrDeactivateCart($cartId: String!) {
        sbrDeactivateCart(cartId: $cartId) {
         message
        }
    }
`;
export default SBR_CART_DEACTIVATE;